import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-rating-star',
  templateUrl: './rating-star.component.html',
  styleUrls: ['./rating-star.component.scss']
})
export class RatingStarComponent implements OnInit, OnChanges, OnDestroy {

  @Input() rating: number = 0;
  @Input() resetRating = new Date();
  @Input() isEdit: boolean;
  @Input() styleClass = '';
  @Output() selected: EventEmitter<any> = new EventEmitter<any>();
  model = 0;
  ceil = 0;

  constructor() {
  }

  ngOnInit(): void {
    this.setRating(this.rating);
  }

  ngOnChanges(changes: any) {
    // console.log(changes);
    if ('resetRating' in changes) {
      this.setRating(0);
    }

    if ('rating' in changes) {
      this.setRating(changes.rating.currentValue);
    }
  }

  ngOnDestroy() {
    this.setRating(0);
  }

  setRating(rating: any) {
    this.model = rating as number;
    this.ceil = Math.ceil(this.model);
  }

  selectRate(rating: number) {
    // console.log(rating);
    if (this.isEdit) {
      this.setRating(rating);
      this.selected.emit(rating);
    }
  }

}
